import script from "./PayConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./PayConfirm.vue?vue&type=style&index=0&id=1f5bd824&lang=scss"

const __exports__ = script;

export default __exports__